import React from 'react'
import ChapterForm from './ChapterForm'
import {Modal} from 'react-bootstrap'


const ChapterEdit = ({show,handleModalClose,handleSubmit,chapter}) => (
  <div>
    <Modal show={show} backdrop="static" keyboard={false} onHide={() => handleModalClose(false)}>
        <Modal.Header closeButton>
            <Modal.Title>Kapitel bearbeiten</Modal.Title>
        </Modal.Header>
          <ChapterForm
             handleSubmit={handleSubmit} chapter={chapter}
            />
        </Modal>
  </div>
)

export default ChapterEdit